import React from "react";
import PropTypes from "prop-types";
import { AmountCell } from "./AmountCell";

export function CategoryItemBody({ categoryItem }) {
  const { amounts = [], title, total, totals } = categoryItem;

  if (totals && totals.length) {
    return (
      <tbody>
        <tr>
          <td></td>
          {totals.map((total, index) => (
            <AmountCell key={index} amount={total} />
          ))}
        </tr>
      </tbody>
    );
  }

  return (
    <tbody>
      <tr>
        <td>{title}</td>
        {amounts.map((amount, index) => (
          <AmountCell key={index} amount={amount} />
        ))}

        {total && <AmountCell amount={total} />}
      </tr>
    </tbody>
  );
}

CategoryItemBody.propTypes = {
  categoryItem: PropTypes.shape({
    amounts: PropTypes.array,
    title: PropTypes.string,
    total: PropTypes.number,
    totals: PropTypes.array,
  }),
};
